export default "/images/vendor/flag-icon-css/flags/1x1/nu.svg?90c38985532899f2b877cd1510f088b0";